import { call } from 'redux-saga/effects';
import { websocketFetch } from 'common/websocket-redux';

export const setFeatureFlag = flag =>
  call(websocketFetch, 'set_feature_flag', flag);
